import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { getStoredData } from "../../../../json/fecthData";
import { toast } from "react-toastify";
import "./EditTablePopup.css"; // create this CSS file

const EditTablePopup = ({ id, api, fields, onSuccess }) => {
  const [formData, setFormData] = useState({});
  const [dropdownData, setDropdownData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [visible, setVisible] = useState(true);

  const popupRef = useRef(null);

  const configData = getStoredData()?.[1] || {};
  const resolvedFields = Array.isArray(fields) ? fields : [];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        let fetchedData = {};
        if (id && id !== "null" && id !== "undefined") {
          const mainData = await axios.get(`${api}/${id}`);
          fetchedData = mainData.data;
        }

        const dropdownResponses = await Promise.all(
          resolvedFields.flatMap((field) => {
            const promises = [];

            if (field.api) {
              promises.push(
                axios.get(field.api).then((res) => ({
                  field: field.fields,
                  values: res.data.map((item, idx) => ({
                    id: item._id ?? `${item.name || "entry"}-${idx}`,
                    label: item[field.apiField || "name"] || "Unnamed",
                  })),
                }))
              );
            }

            if (field.type === "array" && field.subFields) {
  const arrayValue = Array.isArray(formData[field.fields])
    ? formData[field.fields]
    : [];

  return (
    <div key={field.fields} className="form-group array-field">
      <label>{field.title}</label>

      {arrayValue.map((entry, idx) => (
        <div key={idx} className="array-entry">
          <div className="array-entry-header">
            <strong>Entry {idx + 1}</strong>
            <button
              type="button"
              className="array-remove-btn"
              onClick={() => deleteSubArrayEntry(field.fields, idx)}
            >
              ✕
            </button>
          </div>

          {field.subFields.map((sub) => {
            const subVal = entry[sub.fields] ?? "";
            const subDropdown = dropdownData[sub.fields] || [];
            const subReadOnly = sub.edit === "no";

            return (
              <div key={sub.fields} className="form-subfield">
                <label>{sub.title}</label>
                {sub.type === "ObjectId" && sub.api ? (
                  <select
                    value={typeof subVal === "object" ? subVal._id : subVal}
                    onChange={(e) => {
                      const updatedArray = [...arrayValue];
                      updatedArray[idx] = {
                        ...updatedArray[idx],
                        [sub.fields]: e.target.value,
                      };
                      handleChange(field.fields, updatedArray);
                    }}
                    disabled={subReadOnly}
                  >
                    <option value="">Select</option>
                    {subDropdown.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={sub.type === "number" ? "number" : "text"}
                    value={subVal}
                    onChange={(e) => {
                      const updatedArray = [...arrayValue];
                      updatedArray[idx] = {
                        ...updatedArray[idx],
                        [sub.fields]:
                          sub.type === "number"
                            ? +e.target.value
                            : e.target.value,
                      };
                      handleChange(field.fields, updatedArray);
                    }}
                    readOnly={subReadOnly}
                  />
                )}
              </div>
            );
          })}
        </div>
      ))}

      <button
        type="button"
        className="array-add-btn"
        onClick={() => addSubArrayEntry(field.fields, field.subFields)}
      >
        + Add Entry
      </button>
    </div>
  );
}


            return promises;
          })
        );

        const dropdownMap = {};
        dropdownResponses.forEach(({ field, values }) => {
          dropdownMap[field] = values;
        });

        setFormData(fetchedData); // empty if create mode
        setDropdownData(dropdownMap);
      } catch (err) {
        console.error("❌ Failed to fetch data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, api, fields]);

  const addSubArrayEntry = (fieldKey, subFields) => {
    setFormData((prev) => ({
      ...prev,
      [fieldKey]: [
        ...(prev[fieldKey] || []),
        subFields.reduce((acc, sf) => {
          acc[sf.fields] = sf.type === "number" ? 0 : "";
          return acc;
        }, {}),
      ],
    }));
  };

  const deleteSubArrayEntry = (fieldKey, index) => {
    setFormData((prev) => {
      const updated = [...(prev[fieldKey] || [])];
      updated.splice(index, 1);
      return { ...prev, [fieldKey]: updated };
    });
  };

  const handleChange = (field, value) => {
    if (field.includes(".")) {
      const [parent, child] = field.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...(prev[parent] || {}),
          [child]: value,
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const res = id
        ? await axios.put(`${api}/${id}`, formData)
        : await axios.post(api, formData);

      toast.success("✅ Saved successfully!");
      setVisible(false);

      console.log("id check:", id);
      console.log("response:", res.data);

      if (!id || id === "null" || id === "undefined") {
       const newId = res.data?._id;


        if (newId) {
          console.log("✅ New entry created with _id:", newId);
        } else {
          console.warn("⚠️ No _id returned from POST response");
        }
      }

      if (onSuccess) onSuccess(res.data?.data || res.data);
    } catch (err) {
      console.error("❌ Failed to save:", err);
      toast.error("❌ Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="modal-overlay">
        <div className="popup-box">Loading...</div>
      </div>
    );
  if (!visible) return null;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === popupRef.current) {
          setVisible(false);
        }
      }}
    >
      <div className="popup-box" ref={popupRef}>
        <form onSubmit={handleSubmit}>
          <div className="popup-header">
            <h3>{id ? "Edit Entry" : "Create Entry"}</h3>
            <button
              type="button"
              className="popup-close-btn"
              onClick={() => setVisible(false)}
            >
              ✕
            </button>
          </div>

          {resolvedFields.map((field) => {
            const value = field.fields.includes(".")
              ? field.fields
                  .split(".")
                  .reduce((obj, key) => obj?.[key], formData) ?? ""
              : formData[field.fields] ?? "";

            const isReadOnly = field.edit === "no";

            // ✅ Handle arrays with subFields
            if (
              field.type === "array" &&
              Array.isArray(value) &&
              field.subFields
            ) {
              return (
                <div key={field.fields} className="form-group array-field">
                  <label>{field.title}</label>
                  {value.map((entry, idx) => {
                    if (!entry || typeof entry !== "object") return null; // ✅ prevent error

                    return (
                      <div key={idx} className="array-entry">
                        <div className="array-entry-header">
                          <strong>Entry {idx + 1}</strong>
                          <button
                            type="button"
                            className="array-remove-btn"
                            onClick={() =>
                              deleteSubArrayEntry(field.fields, idx)
                            }
                          >
                            ✕
                          </button>
                        </div>

                        {Array.isArray(value) &&
                          value
                            .filter(
                              (entry) => entry && typeof entry === "object"
                            ) // Prevent null
                            .map((entry, idx) => (
                              <div key={idx} className="array-entry">
                                <div className="array-entry-header">
                                  <strong>Entry {idx + 1}</strong>
                                  <button
                                    type="button"
                                    className="array-remove-btn"
                                    onClick={() =>
                                      deleteSubArrayEntry(field.fields, idx)
                                    }
                                  >
                                    ✕
                                  </button>
                                </div>

                                {Array.isArray(field.subFields) &&
                                  field.subFields.map((sub) => {
                                    const subVal = entry[sub.fields] ?? "";
                                    const subDropdown =
                                      dropdownData[sub.fields] || [];
                                    const subReadOnly = sub.edit === "no";

                                    return (
                                      <div
                                        key={sub.fields}
                                        className="form-subfield"
                                      >
                                        <label>{sub.title}</label>
                                        {sub.type === "ObjectId" && sub.api ? (
                                          <select
                                            value={
                                              typeof subVal === "object"
                                                ? subVal?._id
                                                : subVal
                                            }
                                            onChange={(e) => {
                                              const updated = [...value];
                                              updated[idx][sub.fields] =
                                                e.target.value;
                                              handleChange(
                                                field.fields,
                                                updated
                                              );
                                            }}
                                            disabled={subReadOnly}
                                          >
                                            <option value="">Select</option>
                                            {subDropdown.map((opt) => (
                                              <option
                                                key={opt.id}
                                                value={opt.id}
                                              >
                                                {opt.label}
                                              </option>
                                            ))}
                                          </select>
                                        ) : (
                                          <input
                                            type={
                                              sub.type === "number"
                                                ? "number"
                                                : "text"
                                            }
                                            value={subVal}
                                            onChange={(e) => {
                                              const updated = [...value];
                                              updated[idx][sub.fields] =
                                                sub.type === "number"
                                                  ? +e.target.value
                                                  : e.target.value;
                                              handleChange(
                                                field.fields,
                                                updated
                                              );
                                            }}
                                            readOnly={subReadOnly}
                                          />
                                        )}
                                      </div>
                                    );
                                  })}
                              </div>
                            ))}
                      </div>
                    );
                  })}

                  <button
                    type="button"
                    className="array-add-btn"
                    onClick={() =>
                      addSubArrayEntry(field.fields, field.subFields)
                    }
                  >
                    + Add Entry
                  </button>
                </div>
              );
            }

            // 🔁 Fallback for all other types
            return (
              <div key={field.fields} className="form-group">
                <label>{field.title}</label>
                {field.type === "text" || field.type === "number" ? (
                  <input
                    type={field.type}
                    value={value}
                    readOnly={isReadOnly}
                    onChange={(e) =>
                      handleChange(
                        field.fields,
                        field.type === "number"
                          ? +e.target.value
                          : e.target.value
                      )
                    }
                  />
                ) : field.type === "date" ? (
                  <input
                    type="date"
                    value={value?.slice(0, 10)}
                    readOnly={isReadOnly}
                    onChange={(e) => handleChange(field.fields, e.target.value)}
                  />
                ) : field.type === "dropdown" ? (
                  <select
                    value={value}
                    onChange={(e) => handleChange(field.fields, e.target.value)}
                    disabled={isReadOnly}
                  >
                    <option value="">Select</option>
                    {field.options?.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                ) : field.type === "ObjectId" && field.api ? (
                  <select
                    value={typeof value === "object" ? value._id : value}
                    onChange={(e) => handleChange(field.fields, e.target.value)}
                    disabled={isReadOnly}
                  >
                    <option value="">Select</option>
                    {dropdownData[field.fields]?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    value={value}
                    readOnly={isReadOnly}
                    onChange={(e) => handleChange(field.fields, e.target.value)}
                  />
                )}
              </div>
            );
          })}

          <div className="modal-actions">
            <button type="submit" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTablePopup;
